let item = document.querySelector(".gallery-a");
if (item) {
    let container = document.querySelector(".inner-gallery");
    for (let i = 0; i < 116; i++) {
        let clone = item.cloneNode(true);
        container.appendChild(clone);
        clone.children[0].src = `/wp-content/themes/custom-theme/assets/img/gallery/thumbs/run2023_${(i + 1)}_IMGP.jpg`;
        clone.setAttribute("href", `/wp-content/themes/custom-theme/assets/img/gallery/run2023_${(i + 1)}.jpg`);
        clone.setAttribute("data-lightbox", "runImages");
        clone.setAttribute("rel", "lightbox");
    }
    for (let i = 0; i < 145; i++) {
        let clone = item.cloneNode(true);
        container.appendChild(clone);
        clone.children[0].src = `/wp-content/themes/custom-theme/assets/img/gallery/thumbs/run2019_${(i + 1)}_IMGP.jpg`;
        clone.setAttribute("href", `/wp-content/themes/custom-theme/assets/img/gallery/run2019_${(i + 1)}.jpg`);
        clone.setAttribute("data-lightbox", "runImages");
        clone.setAttribute("rel", "lightbox");
    }

    item.remove();

    window.addEventListener("load", ev => {

        lightbox.init();
    });
}

